import { Box, Card } from "@mui/material";

interface CouponPreviewProps {
    title: string;
    selectedTag: string;
    getSelectedTagInfo: () => { value: string; label: string; color: string };
    isEditMode?: boolean;
}

export const CouponPreview: React.FC<CouponPreviewProps> = ({ title, selectedTag, getSelectedTagInfo, isEditMode = false }) => {
    return (
        <Card
            elevation={2}
            sx={{
                borderRadius: 2,
                overflow: 'hidden',
                border: `2px solid ${getSelectedTagInfo().color}`,
            }}
        >
            <Box sx={{ position: 'relative', textAlign: 'center', p: 2 }}>
                <Box
                    component="img"
                    src={isEditMode ? selectedTag : `/assets/images/${selectedTag}.png`}
                    alt="Cupón preview"
                    sx={{
                        width: '100%',
                        maxWidth: 200,
                        height: 'auto',
                        borderRadius: 1,
                        boxShadow: 2,
                    }}
                    onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.style.display = 'none';
                    }}
                />

                {title && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '55%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            color: 'white',
                            fontSize: '10px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.8)',
                            maxWidth: '50px',
                            lineHeight: 1.1,
                            textTransform: 'uppercase',
                            wordBreak: 'break-word',
                        }}
                    >
                        {title}
                    </Box>
                )}
            </Box>
        </Card>

    );
};
